import Lottie from "lottie-react";
import { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { ParamsPageWebView, ParamsDataGetListarCotacoes } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';

import NavTitle from 'components/views/NavTitle';
import ParseWebView from 'components/views/ParseWebView';
import { ContentBodyPage, ContentNewsPage, Banner } from 'components/views/ContainersPage';

import Collapse from '@mui/material/Collapse';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';
import { ReactComponent as IcVehicleExchange } from 'assets/icons/ic-vehicle-exchange.svg';
import { ReactComponent as IcChangeOfOwnership } from 'assets/icons/ic-change-of-ownership.svg';
import { ReactComponent as IcDiscoverOtherPlans } from 'assets/icons/ic-discover-other-plans.svg';

import BannerSeguroDesk from 'assets/images/banners/desk/banner-seguro-desk.png';

import { BoxBanner, Card } from './styles';

import loadingJson from 'assets/animation/loading_quotation.json';

const ExchangeCenter = ({ isWebView }: ParamsPageWebView) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [existActiveChanges, setExistActiveChanges] = useState(false);
    const [notExistActiveChanges, setNotExistActiveChanges] = useState(false);
    const [isLoadingActiveChanges, setIsLoadingActiveChanges] = useState(false);
    const { selectedCar, dataListarCotacoes, handleGetListarCotacoes, handleClearExchanges, handleGetInitialServices } = useContext(DataContext);

    useEffect(() => {
        handleClearExchanges();
        if (!dataListarCotacoes && localStorage.getItem('token') && selectedCar) {
            setIsLoadingActiveChanges(true);
            handleGetListarCotacoes(selectedCar.NR_CNPJ_CPF);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, localStorage.getItem('token')]);

    useEffect(() => {
        if (isWebView && location?.search.includes('token')) {
            localStorage.clear();
            handleGetInitialServices({ token: location?.search.split('=')[1], isWebView: true });
            localStorage.setItem('token', location?.search.split('=')[1]);
        } else if (isWebView && localStorage.getItem('token')) {
            handleGetInitialServices({ token: localStorage.getItem('token')!, isWebView: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dataListarCotacoes) {
            let dataListarCotacoesAux: Array<ParamsDataGetListarCotacoes> = [];
            let dataListarCotacoesAuxListWipe: Array<ParamsDataGetListarCotacoes> = [];

            dataListarCotacoes.map((value) => (dataListarCotacoesAux?.findIndex(({ NR_PLATAFORMA_ORIGEM }) => NR_PLATAFORMA_ORIGEM === value.NR_PLATAFORMA_ORIGEM) === -1) && dataListarCotacoesAux.push(value));

            // eslint-disable-next-line array-callback-return
            dataListarCotacoesAux.map(({ NR_PLATAFORMA_ORIGEM }) => {
                const filterAux = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 3) && (STATUS_PEDIDO_COTACAO < 5)));
                const filterAuxPlataform = dataListarCotacoes.filter(({ NR_PLATAFORMA_ORIGEM: NR_PLATAFORMA_ORIGEM_LIST, NR_TIPO_COTACAO, STATUS_PEDIDO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM_LIST === NR_PLATAFORMA_ORIGEM) && (NR_TIPO_COTACAO === 4) && (STATUS_PEDIDO_COTACAO < 2)));

                if (filterAux?.length > 0) {
                    let max = filterAux.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }

                if (filterAuxPlataform?.length > 0) {
                    let max = filterAuxPlataform.reduce((a, b) => {
                        return new Date(a.DT_COTACAO).getTime() > new Date(b.DT_COTACAO).getTime() ? a : b;
                    });

                    dataListarCotacoesAuxListWipe.push(max);
                }
            });

            if (dataListarCotacoesAuxListWipe.length > 0) {
                setExistActiveChanges(true)
            } else {
                setExistActiveChanges(false);
                setNotExistActiveChanges(true);
                setTimeout(() => {
                    setNotExistActiveChanges(false);
                }, 3000);
            }

            setIsLoadingActiveChanges(false);
        } else if (dataListarCotacoes === false) {
            setExistActiveChanges(false);
            setNotExistActiveChanges(true);

            setTimeout(() => {
                setNotExistActiveChanges(false);
            }, 3000);

            setIsLoadingActiveChanges(false);
        }
    }, [dataListarCotacoes]);

    return (
        <ParseWebView title={isWebView ? '' : 'CENTRAL DE TROCAS'} typePage='page' isWebView={isWebView}>
            <ContentBodyPage>
                <Box sx={{ margin: { xs: '0rem auto 1.68rem', md: '2.25rem auto 3.31rem' } }}>
                    <Collapse in={existActiveChanges} {...(isLoadingActiveChanges ? { timeout: 300 } : {})}>
                        <Box sx={{ cursor: 'pointer', maxWidth: '33.125rem', alignItems: 'center', display: 'grid', gridTemplateColumns: { xs: 'auto 192px auto', md: '6.68rem 300px auto' }, border: '1.23363px solid #10A7E0', padding: { xs: '0', md: '0 3.125rem' } }} onClick={() => navigate('trocas-em-andamento')}>
                            <Box sx={{ 'svg': { width: { xs: '6rem', md: '6.68rem' } } }}>
                                <IcIturanCheck />
                            </Box>
                            <Box sx={{
                                padding: '1.3rem 0 1rem',
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px'
                            }}>
                                <Typography fontWeight={700} sx={{ fontSize: { xs: '1rem', md: '1.375rem' } }}>
                                    TROCA EM ANDAMENTO!
                                </Typography>
                                <Typography fontWeight={600} paddingBottom='2px' sx={{ fontSize: { xs: '.75rem', md: '1.06rem' } }}>
                                    Continue já de onde parou.
                                </Typography>
                                <Typography fontWeight={700} sx={{ textDecoration: 'underline', fontSize: { xs: '.75rem', md: '1.06rem' } }}>
                                    Clique aqui
                                </Typography>
                            </Box>
                            <ArrowForwardIosIcon sx={{ margin: { xs: '0 .5rem 0 .5rem', md: '2rem' }, color: 'primary.light' }} />
                        </Box>
                    </Collapse>

                    <Collapse in={notExistActiveChanges} {...(isLoadingActiveChanges ? { timeout: 300 } : {})}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '1.5rem', alignItems: 'center', border: '1.23363px solid #10A7E0' }}>
                            <Typography fontWeight={700} sx={{ fontSize: { xs: '1rem', md: '1.375rem' } }}>
                                Não há trocas em andamento!
                            </Typography>
                        </Box>
                    </Collapse>

                    <Collapse in={isLoadingActiveChanges}>
                        <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column', height: '115px' }}>
                            <Typography fontSize='1.25rem' fontWeight={700} color='primary.light'>
                                Buscando trocas em andamento
                            </Typography>

                            <Box sx={{ marginTop: '5px', svg: { maxHeight: '90px' } }}>
                                <Lottie animationData={loadingJson} loop={true} />
                            </Box>
                        </Box>
                    </Collapse>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                    <Typography fontSize='1.25rem'>
                        Bem-vindo a <strong>Central de Trocas!</strong>
                    </Typography>
                    <Typography fontSize='1rem' sx={{ paddingTop: { xs: '.5rem', md: '1rem' } }}>
                        Aqui você encontra a facilidade para os seguintes atendimentos:
                    </Typography>

                    <Box sx={{ margin: { xs: '1.43rem 0 2rem', md: '2.31rem 0 3.875rem' }, display: 'grid', gridTemplateColumns: { xs: '80%', md: 'repeat(3, 31.5%);' }, justifyContent: { xs: 'center', md: 'space-between' }, gap: { xs: '.875rem', md: '0' } }}>
                        <Card to={!isLoadingActiveChanges ? 'troca-de-servico' : ''} isDisabled={isLoadingActiveChanges ? 'active' : 'disabled'}>
                            <IcDiscoverOtherPlans />
                            <Box className='SubTitle'>
                                Conheça outros <strong>PLANOS</strong>
                            </Box>
                        </Card>
                        <Card to={!isLoadingActiveChanges ? 'troca-de-titularidade' : ''} isDisabled={isLoadingActiveChanges ? 'active' : 'disabled'}>
                            <IcChangeOfOwnership />
                            <Box className='SubTitle'>
                                Troca de Titularidade
                            </Box>
                        </Card>
                        <Card to={!isLoadingActiveChanges ? 'troca-de-veiculo' : ''} isDisabled={isLoadingActiveChanges ? 'active' : 'disabled'}>
                            <IcVehicleExchange />
                            <Box className='SubTitle'>
                                Troca de Veículo
                            </Box>
                        </Card>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                        IMPORTANTE:
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='19px' textAlign='center' sx={{ width: { xs: 'fit-content', md: '405px' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem 0', md: '.875rem 1.5rem' } }}>
                        As informações do seu processo de troca ficam
                        armazendas aqui. Caso seja interrompido volte e
                        conclua a sua troca de onde parou.
                    </Typography>
                </Box>
            </ContentBodyPage>

            <ContentNewsPage>
                <BoxBanner>
                    <NavTitle title='Trocas' />
                    <Banner bannerImg={BannerSeguroDesk} link='' />
                </BoxBanner>
            </ContentNewsPage>
        </ParseWebView>
    );
}

export default ExchangeCenter;